import type { ReactNode } from "react"
import { HEADING_COLOR, type BlockComponentProps } from "./shared"

export function ImageTextBlock({ content, resolved }: BlockComponentProps) {
  const itH = (content?.heading_hidden || content?.heading_deleted) ? "" : ((content?.heading as string) ?? "")
  const itB = (content?.body_hidden || content?.body_deleted) ? "" : ((content?.body as string) ?? "")
  const itImg = (content?.image_url_deleted || content?.image_url_hidden) ? "" : ((content?.image_url as string) ?? "")
  const itPos = (content?.image_position as "left" | "right") ?? "left"
  const itCta = (content?.cta_text as string) ?? ""
  const itUrl = (content?.cta_url as string) ?? ""
  const primaryColor = "var(--nos-color-primary, #3b82f6)"
  const itOrder = (content?.element_order as string[] | undefined) ?? ["heading", "body", "image_url"]
  const itTextMap: Record<string, ReactNode> = {}
  if (itH) itTextMap["heading"] = <h2 key="heading" className="text-2xl font-bold mb-4" style={{ color: HEADING_COLOR }}>{itH}</h2>
  if (itB) itTextMap["body"] = <p key="body" className="text-muted-foreground mb-4">{itB}</p>
  const textBlock = (
    <div>
      {itOrder.filter((k) => k !== "image_url").map((k) => itTextMap[k] ?? null)}
      {itCta && itUrl && (
        <a href={itUrl} className="inline-block px-4 py-2 rounded-lg font-medium text-white" style={{ backgroundColor: primaryColor }}>
          {itCta}
        </a>
      )}
    </div>
  )
  const imgBlock = itImg ? (
    <img src={itImg} alt={itH || "Image"} className="w-full rounded-lg object-cover" />
  ) : null
  const itSectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass || "py-8"} ${resolved.cornerClass} ${resolved.alignClass}`.trim()
    : "px-4 py-8 @sm:px-6 @md:px-8"
  return (
    <section className={itSectionClass} style={resolved.sectionStyle}>
      <div className={`max-w-4xl mx-auto gap-8 ${imgBlock ? "grid @md:grid-cols-2 @md:items-center" : ""}`}>
        {itPos === "left" ? (
          <>
            {imgBlock}
            {textBlock}
          </>
        ) : (
          <>
            {textBlock}
            {imgBlock}
          </>
        )}
      </div>
    </section>
  )
}
